<template>
  <div id="publishing-author-add">
    <ipub-model
      :title="params.id ? 'Edit Author' : 'Add New Author'"
      width="900px"
      :visable="isVisable"
      @confirm="confirm"
      :confirmText="params.id ? 'Save' : 'Add'"
      @cancel="cancel"
    >
      <ipub-form ref="author-add-form" :model="params" :rules="rules">
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="firstName" label="First Name">
              <ipub-input
                placeholder="First Name"
                v-model.trim="params.firstName"
              />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="lastName" label="Last Name">
              <ipub-input
                placeholder="Last Name"
                v-model.trim="params.lastName"
              />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="email" label="Email">
              <ipub-input placeholder="Email" v-model.trim="params.email" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="orcid" label="">
              <div slot="label">
                <ipub-icon
                  class="ipub-p4"
                  style="font-size: 14px; color: #a6ce39"
                  type="iconORCID"
                />
                ORCID
                <ipub-tooltip placement="right" type="dark">
                  <div slot="title">
                    Like 0000-0001-2345-6789 or 0000123455556789
                  </div>
                  <ipub-icon
                    class="ipub-p1"
                    style="font-size: 14px"
                    type="iconInfo"
                  />
                </ipub-tooltip>
              </div>

              <ipub-input placeholder="ORCID" v-model.trim="params.orcid" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-form-item prop="sup" label="Superscript">
          <ipub-input placeholder="Superscript" v-model.trim="params.sup" />
        </ipub-form-item>
        <ipub-form-item prop="corresponded" label="Correspondence Author">
          <ipub-radio-group
            class="mar-b-10"
            @change="onChange"
            v-model="params.corresponded"
            _label="name"
            :options="[
              { name: 'Yes', value: true },
              { name: 'No', value: false },
            ]"
          />
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import person from '@/api/person'
import check from '@/utils/check'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      params: {
        corresponded: false,
        affiliations: [''],
      },
      rules: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      guestEditor: 'getGuestEditor',
    }),
  },
  watch: {
    isVisable(val) {
      if (!val) {
        this.params = {
          corresponded: false,
          affiliations: [''],
        }
      } else {
        this.params = Object.assign(this.params, this.inputData)
        this.params = JSON.parse(JSON.stringify(this.params))
        this.rules.email[0].required = this.params.corresponded || false
      }
    },
  },
  mounted() {
    this.getRules()
  },
  methods: {
    async checkEmail() {
      if (this.params.id || !this.params.email) {
        return
      }
      const { journalId, specialId } = this.inputData
      const res = await person.checkEmail(this.params.email, {
        journalId,
        specialId,
      })
      if (res && res.length) {
        const data = res[0]
        data.ebed = data.type.includes('EDITORIAL_BOARD')
        data.rbed = data.type.includes('REVIEWER_BOARD')
        data.geed = data.type.includes('GUEST_EDITOR')
        data.corresponded = false
        delete data.id
        this.params = Object.assign(data, this.params)
        return data
      }
    },
    addMore(key) {
      this.params[key].push('')
    },
    delMore(key, index) {
      if (this.params[key].length === 1) {
        return
      }
      this.params[key].splice(index, 1)
    },
    getMore(key) {
      const arr = []
      this.params[key + 's'].forEach((item) => {
        if (item) {
          arr.push(item)
        }
      })
      this.params[key] = arr.join(';')
    },
    async confirm() {
      const flag = this.$refs['author-add-form'].validate()
      if (flag) {
        this.$message.success({
          title: 'Success',
          content: 'This Author has been saved!',
        })
        this.$emit('confirm', this.params)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    onChange(val) {
      this.rules.email[0].required = val
    },
    checkOrcid(val) {
      const exg1 = /^(([0-9]{4,4})-){3,3}[0-9]{4,4}\b$/
      const exg2 = /^[0-9]{16,16}$/
      // console.log(val.match(exg1), '校验', val.match(exg2))
      if (!val) {
        return true
      }
      if (val.match(exg1) || val.match(exg2)) {
        return true
      } else {
        return false
      }
    },

    getRules() {
      this.rules = {
        firstName: [
          {
            required: false,
            message: 'First Name' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        lastName: [
          {
            required: false,
            message: 'Last Name' + this.LANGUAGE[this.language].noEmpty,
          },
        ],
        email: [
          {
            required: false,
            message: 'Email' + this.LANGUAGE[this.language].noEmpty,
          },
          {
            type: 'email',
            message: this.LANGUAGE[this.language].enterCorrent + 'Email',
          },
          { fun: this.checkEmail },
        ],
        orcid: [
          {
            fun: check.orcid,
            message: `Encourage input ORCID`,
          },
        ],
        // sup: [
        //   {
        //     required: true,
        //     message:
        //       'Superscript' +
        //       this.LANGUAGE[this.language].noEmpty
        //   }
        // ]
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#publishing-article-add {
  .upload-content {
    height: 140px;
    width: 135px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    &-img {
      border-radius: 50%;
      height: 140px;
      width: 140px;
      font-size: 170px;
      color: $line_color;
      background: $font_color;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &-icon {
      font-size: 20px;
      position: absolute;
      bottom: -16px;
      left: calc(50% - 16px);
      width: 32px;
      height: 32px;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      background: $main_color;
      color: $content_color;
      cursor: pointer;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
